import PropTypes from "prop-types";
import React, { Component } from "react";

import SearchBox from "../../shared/components/SearchBox";

class LogsGlobalFilter extends Component {
  handleChange = e => {
    const { setFilter } = this.props;
    const filter = e.target.value;

    setFilter("global", filter);
  };

  resetFilter = () => {
    const { setFilter } = this.props;
    setFilter("global", "");
  };

  render() {
    const { filter } = this.props;

    return (
      <SearchBox
        value={filter}
        placeholder="Filter logs"
        onChange={e => this.handleChange(e)}
        onReset={() => this.resetFilter()}
        style={{ marginBottom: "0" }}
      />
    );
  }
}

LogsGlobalFilter.propTypes = {
  filter: PropTypes.string,
  setFilter: PropTypes.func.isRequired
};

LogsGlobalFilter.defaultProps = {
  filter: ""
};

export default LogsGlobalFilter;
